// import { UIHelpers } from "src/app/core/ui-helpers";

export class PhoneNumber {

    plainText:string = "";

    private static validPatterns = new Map<string,string>([
        ["US", "##########"],
        ["CA", "##########"],
    ]);

    static validate(phone:string, ccCode:string):boolean {
        
        if (PhoneNumber.validPatterns.has(ccCode)) {
            let fmt = PhoneNumber.validPatterns.get(ccCode);
            if (!fmt || phone.replace(/\D/g, "").length != fmt.length) {
                return false;
            }
        }

        return true;
    }

    // format(ccCode:string) {
    //     return UIHelpers.formatPhone(this.plainText, ccCode);
    // }

    constructor(phone:string, ccCode:string) {
        if (!phone) {
            throw "Invalid phone number in constructor";
        } else if (!ccCode || ccCode == "") {
            throw "Invalid country code in constructor";
        } else if (!PhoneNumber.validate(phone, ccCode)) {
            throw "Invalid phone number in constructor";
        } 

        this.plainText = phone;
    }

}